module.exports = __webpack_public_path__ + "static/img/statement.acf1f81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/statement.jpg
// module id = iwIL
// module chunks = 0